module.exports = __webpack_public_path__ + "assets/img/24_1072.2e192001.jpg";